import React from "react";
import { motion } from "framer-motion";

const PageWrapper = ({ children, title, subtitle, actions }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{ duration: 0.35, ease: [0.2, 0.7, 0.2, 1] }}
      className="w-full"
    >
      {/* Page Header */}
      {(title || actions) && (
        <div className="mb-7 flex flex-col md:flex-row md:items-end md:justify-between gap-3">
          <div className="min-w-0">
            {title && <h1 className="page-title">{title}</h1>}
            {subtitle && (
              <p className="text-[14.5px] text-muted mt-1.5 leading-snug">
                {subtitle}
              </p>
            )}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
      )}

      {/* Page Content */}
      <div>{children}</div>
    </motion.div>
  );
};

export default PageWrapper;
